import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { SolicitacaoDiretorService } from '@/core/api/sicom-api/servicos/pessoa-juridica/solicitacao-diretor/solicitacao-diretor.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { SolicitacaoDiretorRequest, SolicitacaoDiretorResponse } from '@/core/api/sicom-api/servicos/pessoa-juridica/solicitacao-diretor/solicitacao-diretor.model';

@Injectable({ providedIn: 'root' })
export class SolicitacaoDiretorServicosService {
    constructor(
        private api: SolicitacaoDiretorService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: SolicitacaoDiretorRequest, context?: HttpContext): Observable<SolicitacaoDiretorResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
